import { connect } from 'react-redux';
import { getCurrentBranding } from '../../../redux/reducers/branding.reducer';
import LazyLoadCustom from '../LazyLoadCustom/LazyLoadCustom';
import { CopyAll, Logout, NotificationsNoneOutlined } from '@mui/icons-material';
import { Avatar, IconButton, Popover, Box, Typography, Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { getUserProfile } from '../../../redux/reducers/userProfile.reducer';
import { useEffect, useState } from 'react';
import {
  apiValidation,
  get,
  getAvatarForUser,
  isIosApp,
  isWebView,
  post,
} from '../../../Utilities';
import {
  getClientId,
  getClientUserId,
  getRoleArray,
} from '../../../redux/reducers/clientUserId.reducer';
import InitialsAvatar from '../../Login/Preloader/InitialsAvatar';
import { Settings, User, FileText } from 'lucide-react';
import Swal from 'sweetalert2';
import { clientUserIdActions } from '../../../redux/actions/clientUserId.action';
import { userProfileActions } from '../../../redux/actions/userProfile.action';
import { firstTimeLoginActions } from '../../../redux/actions/firsttimeLogin.action';
import { feeActions } from '../../../redux/actions/fees.actions';
import { Button } from 'react-bootstrap';

const useStyles = makeStyles((theme) => ({
  popover: {
    '& .MuiPopover-paper': {
      borderRadius: '16px',
      boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
      border: '1px solid #e5e7eb',
      minWidth: '280px',
      padding: 0,
      overflow: 'visible',
    },
  },
  profileHeader: {
    padding: '24px 24px 16px 24px',
    display: 'flex',

    alignItems: 'center',
    gap: '14px',
    color: '#2b2d42',
    position: 'relative',
  },
  profileAvatar: {
    width: '64px !important',
    height: '64px !important',
    marginBottom: '12px',
    border: '3px solid rgba(255, 255, 255, 0.2)',
    fontSize: '24px',
    fontWeight: 600,
  },
  profileName: {
    fontSize: '16px',
    fontWeight: 600,
    marginBottom: '0px',
    color: '#2b2d42',
  },
  profileEmail: {
    fontSize: '14px',
    opacity: 0.9,
    color: '#2b2d42',
  },
  manageProfileButton: {
    borderRadius: '8px',
    color: 'white',
    width: '100%',
  },
  manageProfileButtonContainer: {
    margin: '2px 24px',
  },
  menuSection: {
    padding: '8px 0',
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 24px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontSize: '14px',
    fontWeight: 500,
    color: '#374151',
    '&:hover': {
      backgroundColor: '#f9fafb',
      color: '#1f2937',
    },
  },
  menuItemIcon: {
    marginRight: '12px',
    width: '18px',
    height: '18px',
    color: '#6b7280',
  },
  signOutItem: {
    color: '#dc2626 !important',
    borderTop: '1px solid #e5e7eb',
    marginTop: '8px',
    paddingTop: '16px',
    '&:hover': {
      backgroundColor: '#fef2f2 !important',
      color: '#dc2626 !important',
    },
  },
  divider: {
    margin: '0 24px',
    backgroundColor: '#e5e7eb',
  },
}));

function moveLastTwoToFront(str) {
  if (str.length <= 2) return str;
  return str.slice(-2) + ' ' + str.slice(0, -2);
}

const PageHeaderNew = (props) => {
  const classes = useStyles();
  const {
    branding,
    history,
    userProfile,
    isClientColor,
    clientUserId,
    roleArray,
    clearClientIdDetails,
    clearProfile,
    setFeeCustomPlanArrayToStore,
    setFirstTimeLoginToStore,
    clientId,
  } = props;

  const [greeting, setTime] = useState('');
  const [badgeValue, setBadgeValue] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const goToProfile = () => {
    const { push } = history;
    handleClose();
    if (history.location.pathname !== '/profile') {
      push({ pathname: '/profile' });
    }
  };

  const goToNotifications = () => {
    const { push } = history;
    push('/notifications');
  };

  const partsOfDay = () => {
    const hours = new Date().getHours();
    if (hours >= 0 && hours < 12) setTime('Good Morning 🌤');
    else if (hours >= 12 && hours <= 17) setTime('Good Afternoon ☀️');
    else if (hours >= 17 && hours < 21) setTime('Good Evening 🌜');
    else if (hours >= 21 && hours < 24) setTime('Good Evening 🌜');
  };

  useEffect(() => {
    partsOfDay();
    get({ client_user_id: clientUserId }, '/ckeckNewNotifications').then((res) => {
      if (res && res.success) {
        setBadgeValue(res.result);
      }
    });
  }, []);

  const logout = () => {
    const logoutPayload = {
      client_user_id: clientUserId,
      device_type: isWebView ? 'android' : isIosApp ? 'ios' : 'web',
    };
    if (isWebView && typeof window.Android.removeClientUserId !== 'undefined') {
      window.Android.removeClientUserId();
      if (typeof window.Android.deleteFCMToken !== 'undefined') {
        window.Android.deleteFCMToken();
      }
    }
    if (isWebView && typeof window.Android.unsubscribeForNotification !== 'undefined') {
      window.Android.unsubscribeForNotification();
    } else if (isIosApp) {
      iosCaller('unsubscribeForNotification');
    }
    post(logoutPayload, '/logoutUser')
      .then((res) => {
        const result = apiValidation(res);
        if (result) {
          clearProfile();
          sessionStorage.clear();
          clearClientIdDetails();
          setFeeCustomPlanArrayToStore([]);
          setFirstTimeLoginToStore(false);
          history.push({ pathname: '/preload' });
        }
      })
      .catch(() => {
        Swal.fire({
          icon: 'error',
          title: 'Oops!',
          text: `Unable to logout :(`,
          timer: 3000,
        });
      });
  };

  const handleMenuItemClick = (action) => {
    handleClose();
    action();
  };

  return (
    <div
      style={
        isClientColor ? { backgroundColor: 'var(--primary-blue)' } : { backgroundColor: 'white' }
      }
      className='PageHeader__headerNew'
    >
      <div className='pr-3 pl-2 py-1 d-flex align-items-center PageHeader__headerNewContainer justify-content-between'>
        <div className='d-flex align-items-center'>
          <LazyLoadCustom
            className='PageHeader__clientLogo'
            src={branding?.branding?.client_logo}
          />
          <p className='mb-0 ml-3 PageHeader__greeting font'>{greeting}</p>
          <p className='mb-0 ml-3 PageHeader__clientName font'>{branding?.branding?.client_name}</p>
        </div>
        <div className='d-flex align-items-center position-relative'>
          <p className='PageHeader__nameGreetingText font'>
            {moveLastTwoToFront(greeting).trim()}, {userProfile?.firstName}
          </p>
          <IconButton onClick={goToNotifications} className='mx-1 position-relative'>
            <NotificationsNoneOutlined />
            {badgeValue ? <div className='PageHeader__notiiconBadge'>{badgeValue}</div> : null}
          </IconButton>
          {!userProfile.profile_image ? (
            <InitialsAvatar
              onClick={clientId == 137 ? goToProfile : handleClick}
              role='button'
              name={`${userProfile.firstName} ${userProfile.lastName}`}
              color={getAvatarForUser(clientUserId)}
              size='sm'
            />
          ) : (
            <Avatar
              onClick={clientId == 137 ? goToProfile : handleClick}
              style={{ width: '30px', height: '30px', cursor: 'pointer' }}
              alt={`${userProfile.first_name} ${userProfile.last_name}`}
              src={userProfile.profile_image}
              sx={{ bgcolor: 'red' }}
            />
          )}
        </div>
      </div>

      <Popover
        className={classes.popover}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Box>
          {/* Profile Header Section */}
          <div className={classes.profileHeader}>
            {!userProfile.profile_image ? (
              <InitialsAvatar
                // className={classes.profileAvatar}
                name={`${userProfile.firstName} ${userProfile.lastName}`}
                color={getAvatarForUser(clientUserId)}
                role='button'
                size='md'
              />
            ) : (
              <Avatar
                className={classes.profileAvatar}
                alt={`${userProfile.first_name} ${userProfile.last_name}`}
                src={userProfile.profile_image}
              />
            )}
            <div>
              <Typography className={`font-bold ${classes.profileName} clampOn1Line`}>
                {userProfile.firstName?.trim()} {userProfile.lastName?.trim()}
              </Typography>
              {userProfile.contact && (
                <Typography className={`text-muted ${classes.profileEmail}`}>
                  +{userProfile.country_code || '91'} {userProfile.contact}
                </Typography>
              )}
            </div>
          </div>

          <div className={classes.manageProfileButtonContainer}>
            <Button
              fullWidth
              variant='customPrimary'
              className={classes.manageProfileButton}
              onClick={() => handleMenuItemClick(goToProfile)}
            >
              Manage your profile
            </Button>
          </div>

          {/* Menu Items */}
          <div className={classes.menuSection}>
            {(roleArray.includes(4) || roleArray.includes(5)) && (
              <div
                className={classes.menuItem}
                onClick={() =>
                  handleMenuItemClick(() => {
                    // Navigate to invoice page
                    history.push('/invoices-list');
                  })
                }
              >
                <FileText className={classes.menuItemIcon} />
                Invoices
              </div>
            )}

            {(roleArray.includes(4) || roleArray.includes(5)) && (
              <div
                className={classes.menuItem}
                onClick={() =>
                  handleMenuItemClick(() => {
                    history.push('/app-settings');
                  })
                }
              >
                <Settings className={classes.menuItemIcon} />
                Settings
              </div>
            )}

            <div
              className={`${classes.menuItem} ${classes.signOutItem}`}
              onClick={() => handleMenuItemClick(logout)}
            >
              <Logout className={classes.menuItemIcon} />
              Sign Out
            </div>
          </div>
        </Box>
      </Popover>
    </div>
  );
};

const mapStateToProps = (state) => ({
  branding: getCurrentBranding(state),
  clientId: getClientId(state),
  userProfile: getUserProfile(state),
  clientUserId: getClientUserId(state),
  roleArray: getRoleArray(state),
});

const mapDispatchToProps = (dispatch) => {
  return {
    clearClientIdDetails: () => {
      dispatch(clientUserIdActions.clearClientIdDetails());
    },
    clearProfile: () => {
      dispatch(userProfileActions.clearUserProfile());
    },
    setFirstTimeLoginToStore: () => {
      dispatch(firstTimeLoginActions.setFirstTimeLoginToStore());
    },
    setFeeCustomPlanArrayToStore: () => {
      dispatch(feeActions.setFeeCustomPlanArrayToStore());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PageHeaderNew);
